const baseURL = 'https://indumentaria.komerzy.com';

export default baseURL;
